//header events//

import { trackEvent } from './AppInsights.service';

export const trackHeaderMenuClick = (label) => {
  trackEvent(`header-${label}-click`);
};

export const trackHeaderLoginClick = () => {
  trackEvent(`header-Login-click`);
};

//footer event//
export const trackFooterEvent = (linkText) => {
  trackEvent(`footer-${linkText}-click`);
};

//index page events//
const trackGetActivatedButton = () => {
  trackEvent("home-Let's get activated CTA-click");
};

const trackVideoPlay = () => {
  trackEvent('home-Video started playing');
};

const trackVideoCta = () => {
  trackEvent('home-Video CTA-click');
};

const trackReadMoreButton = () => {
  trackEvent('home-Read more CTA-click');
};

const trackFAQsButton = () => {
  trackEvent('home-View more FAQs CTA-click');
};

export const indexPageEvents = {
  trackGetActivatedButton,
  trackVideoPlay,
  trackVideoCta,
  trackReadMoreButton,
  trackFAQsButton,
};

//Faq page events//
export const trackFAQClick = (faqName) => {
  trackEvent(`faqs-${faqName}-click`);
};

//Activate Your Card Page Events//
const trackAppleClick = (location) => {
  trackEvent(`activate-${location}-app store-click`);
};

const trackGoogleClick = (location) => {
  trackEvent(`activate-${location}-play store-click`);
};

const oamSignInClick = () => {
  trackEvent(`activate-OAM Sign in-click`);
};

const oamActivateClick = () => {
  trackEvent(`activate-OAM Activate Card-click`);
};

const trackExploreFaqs = () => {
  trackEvent(`activate-Explore FAQs-click`);
};

export const activateYourCardPageEvents = {
  trackAppleClick,
  trackGoogleClick,
  oamActivateClick,
  oamSignInClick,
  trackExploreFaqs,
};

// moving to Pulse Page Events

export const trackMovingToPulseCategoryClick = (category) => {
  trackEvent(`moving-to-pulse-${category}-click`);
};

export const trackMovingToPulseQuestionClick = (question) => {
  trackEvent(`moving-to-pulse-${question}-click`);
};

export const activateMovingToPulsePageEvents = {
  trackMovingToPulseCategoryClick,
  trackMovingToPulseQuestionClick,
};
